// K8 (Finar 2026-10-28) — kısmi değer TEK kuralı: prompt/DOCX "†", grid amber noktası ve Excel
// hücre notu aynı kararı buradan alır. Kısmi = dolu hücre ∧ (XXX girdisi var ∨ ölçülmeyen kalem
// atlandı ∨ ölçülmeyen işletme toplama girmedi). Değeri olmayan (HESAPLANAMADI/XXX) hücre kısmi değildir.
import type { KpiResolvedCell } from "../schemas/kpi.js";

export function isPartialKpiCell(
  cell:
    | Pick<KpiResolvedCell, "status" | "hasPending" | "partialRefs" | "partialEntityIds">
    | undefined,
): boolean {
  if (cell?.status !== "filled") return false;
  return (
    cell.hasPending === true ||
    (cell.partialRefs?.length ?? 0) > 0 ||
    (cell.partialEntityIds?.length ?? 0) > 0
  );
}
